import React, { Component } from "react"
import theme from "../styles/theme"
import styled from "@emotion/styled"

const Outer = styled.div`
  padding: 0 32px;
`
const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 32px;
  max-width: ${theme.maxwidth.default};
  margin-left: auto;
  margin-right: auto;
  @media (max-width: ${theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
  }
`
const Content = styled.div`
  grid-column: span 2;
  @media (max-width: ${theme.breakpoints.tablet}) {
    grid-column: span 1;
  }
`
const ColourCard = styled.div`
  padding: 32px;
  &:nth-of-type(1) {
    background-color: rgba(0, 203, 204, 0.1);
  }
  &:nth-of-type(2) {
    background-color: rgba(255, 169, 136, 0.1);
  }
  &:nth-of-type(3) {
    background-color: rgba(253, 68, 146, 0.1);
  }
  &:nth-of-type(4) {
    background-color: rgba(0, 89, 195, 0.1);
  }
`

export default class FeatureList extends Component {
  render() {
    return (
      <Outer>
        <Container>
          <Content>{this.props.content}</Content>
          <ColourCard>
            <h3>Get investment ready</h3>
            <p>
              Demonstrate that your key fundamentals are in place for growth and
              scale, as accelerators, investors, mentors, and partners look to
              understand and buy in to your story.
            </p>
          </ColourCard>
          <ColourCard>
            <h3>Scale up</h3>
            <p>
              Define and put in place the flexible and sturdy sales
              infrastructure to allow your business to grow quickly and
              efficiently.
            </p>
          </ColourCard>
          <ColourCard>
            <h3>Power in Professionalism</h3>
            <p>
              By defining and streamlining your sales process, you will bring an
              extra level of professionalism to your prospects’ journey,
              interacting with all market participants in a uniform, thoughtful
              and consistent manner.
            </p>
          </ColourCard>
          <ColourCard>
            <h3>Provide Clarity</h3>
            <p>
              Internal and external stakeholders, including investors, can see
              your sales process, business strategy and revenue goals all in one
              place, facilitating greater transparency and more streamlined
              communication.
            </p>
          </ColourCard>
        </Container>
      </Outer>
    )
  }
}
